<template>
  <a-row class="search__box--row">
    <a-col :span="12" class="search__left--col">
      <span>项目:</span>
      <!-- <a-input size="large" v-model="searchParams.projectName" placeholder="输入项目名称" class="left__input--style"/> -->
      <a-select
        show-search
        :value="selectProjectId"
        placeholder="输入项目名称"
        class="left__input--style"
        :default-active-first-option="false"
        :show-arrow="false"
        :filter-option="false"
        :not-found-content="null"
        @search="handleSearch"
        @change="handleChange"
      >
        <a-select-option
          v-for="d in projectNameOptions"
          :value="d.id"
          :key="d.id"
        >
          {{ d.name }}
        </a-select-option>
      </a-select>
    </a-col>
    <a-col :span="12" class="search__right--col">
      <a-input-search
        v-model="searchParams"
        class="right__inputSearch"
        size="large"
        placeholder="请输入搜索关键字"
      />
    </a-col>
  </a-row>
</template>
<script>
import viewProjectTag from "@/request/api-manager/viewProjectTag.js";
export default {
  name: "TemplateSearch",
  props: {
    selectProjectId: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      searchParams: "", // 搜索的参数
      projectNameOptions: [], // 项目候选项
      key: "",
      frameworkId: "",
    };
  },
  watch: {
    searchParams(val) {
      this.$emit("search", val);
    },
  },
  methods: {
    getProjectList() {
      let projectNameOptions = [];
      return new Promise((resolve, reject) => {
        viewProjectTag.getListByFrameworkId({
          frameworkId: this.frameworkId,
          projectTitle: `*${this.key}*`,
          pageSize: 10,
          pageNo: 1,
        }).then((res) => {
          if (res.result.total > 0) {
            res.result.records.forEach((item) => {
              projectNameOptions.push({
                id: item.id,
                name: item.projectTitle,
              });
            });
          }
          this.projectNameOptions = projectNameOptions
          resolve()
        });
      })
    },
    handleSearch(val) {
      // let params = {
      //   frameworkId: res.result.frameworkId,
      //   projectName: `*${val}*`,
      //   pageSize: 10,
      //   pageNo: 1,
      // };
      this.key = val
      this.getProjectList();
    },
    handleChange(val) {
      console.log(val, "handleChange");
      this.$emit("selectProject", val);
    },
  },
  mounted() {
    viewProjectTag
      .queryByProjectId({ id: this.$route.query.id })
      .then((res) => {
        this.frameworkId = res.result.frameworkId;
        this.getProjectList().then(() => {
          if(this.projectNameOptions.length > 0){
            this.selectProjectId = this.projectNameOptions[0].id
            this.$emit("selectProject", this.selectProjectId);
            console.log('selectProject', this.selectProjectId)
          }
        });
      });
    // this.getPageList()
  },
};
</script>
<style scoped lang="less">
@import "./index.less";
</style>